import React from 'react'

interface AppAndroidIconProps {
  width?: number
  height?: number
}

const AppAndroidIcon = ({ width = 152, height = 46 }: AppAndroidIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 152 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="app-android-icon"
  >
    <rect x="0.5" y="0.500549" width="151" height="45" rx="7.5" fill="black" />
    <path
      d="M74.2507 25.2033C71.8444 25.2033 69.9395 27.0914 69.9395 29.7138C69.9395 32.2313 71.8444 34.2243 74.2507 34.2243C76.6569 34.2243 78.5618 32.3362 78.5618 29.7138C78.5618 26.9866 76.6569 25.2033 74.2507 25.2033ZM74.2507 32.3362C72.9473 32.3362 71.8444 31.1824 71.8444 29.6089C71.8444 28.0355 72.9473 26.8817 74.2507 26.8817C75.554 26.8817 76.6569 27.9306 76.6569 29.6089C76.6569 31.1824 75.554 32.3362 74.2507 32.3362ZM64.9265 25.2033C62.5203 25.2033 60.6154 27.0914 60.6154 29.7138C60.6154 32.2313 62.5203 34.2243 64.9265 34.2243C67.3328 34.2243 69.2377 32.3362 69.2377 29.7138C69.2377 26.9866 67.3328 25.2033 64.9265 25.2033ZM64.9265 32.3362C63.6232 32.3362 62.5203 31.1824 62.5203 29.6089C62.5203 28.0355 63.6232 26.8817 64.9265 26.8817C66.2299 26.8817 67.3328 27.9306 67.3328 29.6089C67.3328 31.1824 66.2299 32.3362 64.9265 32.3362ZM53.7978 26.567V28.4551H58.1089C58.0087 29.504 57.6076 30.3432 57.1063 30.8677C56.5048 31.4971 55.5022 32.2313 53.7978 32.2313C51.0908 32.2313 49.0856 30.0285 49.0856 27.1963C49.0856 24.3642 51.191 22.1614 53.7978 22.1614C55.2014 22.1614 56.3043 22.7907 57.1063 23.525L58.4097 22.1614C57.3068 21.1124 55.9032 20.2733 53.898 20.2733C50.2887 20.2733 47.1807 23.4201 47.1807 27.1963C47.1807 30.9726 50.2887 34.1194 53.898 34.1194C55.9032 34.1194 57.3068 33.4901 58.51 32.1264C59.7131 30.8677 60.1141 29.0845 60.1141 27.7208C60.1141 27.3012 60.1141 26.8817 60.0138 26.567H53.7978ZM99.3155 28.0355C98.9144 26.9866 97.9118 25.2033 95.7061 25.2033C93.5004 25.2033 91.6958 26.9866 91.6958 29.7138C91.6958 32.2313 93.5004 34.2243 95.9066 34.2243C97.8116 34.2243 99.0147 32.9656 99.4157 32.2313L98.0121 31.1824C97.5108 31.9166 96.9092 32.4411 95.9066 32.4411C94.904 32.4411 94.3025 32.0215 93.8012 31.0775L99.516 28.56L99.3155 28.0355ZM93.5004 29.504C93.5004 27.8257 94.8038 26.8817 95.7061 26.8817C96.4079 26.8817 97.1097 27.3012 97.3103 27.8257L93.5004 29.504ZM88.7882 33.8047H90.6932V20.6928H88.7882V33.8047ZM85.7805 26.1474C85.2792 25.6229 84.4771 25.0984 83.4745 25.0984C81.3691 25.0984 79.3639 27.0914 79.3639 29.6089C79.3639 32.1264 81.2688 34.0145 83.4745 34.0145C84.4771 34.0145 85.2792 33.4901 85.6802 32.9656H85.7805V33.595C85.7805 35.2733 84.8781 36.2173 83.4745 36.2173C82.3717 36.2173 81.5696 35.3782 81.3691 34.6439L79.7649 35.3782C80.2662 36.532 81.4693 38.0006 83.5748 38.0006C85.7805 38.0006 87.5851 36.6369 87.5851 33.3852V25.4131H85.7805V26.1474ZM83.5748 32.3362C82.2714 32.3362 81.1685 31.1824 81.1685 29.6089C81.1685 28.0355 82.2714 26.8817 83.5748 26.8817C84.8781 26.8817 85.8807 28.0355 85.8807 29.6089C85.8807 31.1824 84.8781 32.3362 83.5748 32.3362ZM108.038 20.6928H103.526V33.8047H105.431V28.8747H108.038C110.143 28.8747 112.149 27.3012 112.149 24.7838C112.149 22.2663 110.143 20.6928 108.038 20.6928ZM108.138 26.9866H105.431V22.4761H108.138C109.542 22.4761 110.344 23.7348 110.344 24.6789C110.244 25.8327 109.442 26.9866 108.138 26.9866ZM119.668 25.0984C118.264 25.0984 116.861 25.7278 116.36 27.0914L118.064 27.8257C118.465 27.0914 119.067 26.8817 119.768 26.8817C120.771 26.8817 121.673 27.511 121.774 28.56V28.6649C121.473 28.4551 120.671 28.1404 119.869 28.1404C118.064 28.1404 116.259 29.1894 116.259 31.0775C116.259 32.8607 117.763 34.0145 119.367 34.0145C120.671 34.0145 121.272 33.3852 121.774 32.7558H121.874V33.8047H123.678V28.7698C123.478 26.4621 121.774 25.0984 119.668 25.0984ZM119.468 32.3362C118.866 32.3362 117.964 32.0215 117.964 31.1824C117.964 30.1334 119.067 29.8187 119.969 29.8187C120.771 29.8187 121.172 30.0285 121.673 30.2383C121.473 31.497 120.47 32.3362 119.468 32.3362ZM129.995 25.4131L127.889 31.0775H127.789L125.583 25.4131H123.578L126.887 33.3852L124.982 37.7908H126.887L132 25.4131H129.995ZM113.151 33.8047H115.056V20.6928H113.151V33.8047Z"
      fill="var(--color-grayScale-white)"
    />
    <path
      d="M16.401 10.2033C16.1003 10.518 16 11.0425 16 11.6719V34.8537C16 35.4831 16.2005 36.0076 16.5013 36.3223L16.6016 36.4272L29.0337 23.4201V23.3153V23.2104L16.401 10.2033Z"
      fill="url(#paint0_linear_32042_47839)"
    />
    <path
      d="M33.0437 27.8258L28.9331 23.5251V23.3153V23.2104L33.0437 18.9097L33.144 19.0146L38.0567 21.9517C39.4603 22.7908 39.4603 24.1545 38.0567 24.9936L33.0437 27.8258Z"
      fill="url(#paint1_linear_32042_47839)"
    />
    <path
      d="M33.1442 27.7209L28.9333 23.3153L16.4009 36.4272C16.9022 36.9517 17.604 36.9517 18.5063 36.5321L33.1442 27.7209Z"
      fill="url(#paint2_linear_32042_47839)"
    />
    <path
      d="M33.1442 18.9097L18.5063 10.2034C17.604 9.67894 16.9022 9.78384 16.4009 10.3083L28.9333 23.3153L33.1442 18.9097Z"
      fill="url(#paint3_linear_32042_47839)"
    />
    <path
      opacity="0.2"
      d="M33.0439 27.616L18.5063 36.2174C17.7042 36.7419 17.0024 36.637 16.5011 36.2174L16.4009 36.3223L16.5011 36.4272C17.0024 36.8468 17.7042 36.9517 18.5063 36.4272L33.0439 27.616Z"
      fill="black"
    />
    <path
      opacity="0.12"
      d="M16.401 36.2174C16.1003 35.9027 16 35.3783 16 34.7489V34.8538C16 35.4831 16.2005 36.0076 16.5013 36.3223V36.2174H16.401Z"
      fill="black"
    />
    <path
      opacity="0.12"
      d="M38.0569 24.6789L33.0439 27.616L33.1442 27.7209L38.0569 24.7838C38.7587 24.3642 39.0595 23.8397 39.0595 23.3153C39.0595 23.8397 38.6585 24.2593 38.0569 24.6789Z"
      fill="black"
    />
    <path
      opacity="0.25"
      d="M18.5065 10.3082L38.057 21.9516C38.6586 22.3712 39.0596 22.7908 39.0596 23.3153C39.0596 22.7908 38.7588 22.2663 38.057 21.8467L18.5065 10.2034C17.1029 9.36419 16 9.99356 16 11.6719V11.7768C16 10.2034 17.1029 9.46908 18.5065 10.3082Z"
      fill="var(--color-grayScale-white)"
    />
    <path
      d="M47.3813 15.9726V9.67885H49.186C50.0883 9.67885 50.8904 9.99353 51.3917 10.518C51.9933 11.1474 52.1938 11.8816 52.1938 12.8257C52.1938 13.7698 51.893 14.504 51.3917 15.1334C50.7902 15.7628 50.0883 15.9726 49.186 15.9726H47.3813ZM48.1834 15.2383H49.2863C49.9881 15.2383 50.4894 15.0285 50.8904 14.6089C51.2915 14.1893 51.492 13.56 51.492 12.8257C51.492 12.0914 51.2915 11.4621 50.8904 11.0425C50.4894 10.6229 49.8878 10.4131 49.2863 10.4131H48.1834V15.2383Z"
      fill="var(--color-grayScale-white)"
      stroke="white"
      strokeWidth="0.2"
      strokeMiterlimit="10"
    />
    <path
      d="M53.397 15.9725V9.67883H54.199V15.9725H53.397Z"
      fill="var(--color-grayScale-white)"
      stroke="white"
      strokeWidth="0.2"
      strokeMiterlimit="10"
    />
    <path
      d="M57.207 16.0775C56.806 16.0775 56.3047 15.9726 55.9036 15.6579C55.5026 15.3433 55.2018 14.9237 55.1016 14.3992L55.8034 14.0845C55.9036 14.3992 56.1042 14.7139 56.3047 14.9237C56.6055 15.1335 56.9062 15.2384 57.207 15.2384C57.5078 15.2384 57.8086 15.1335 58.1093 14.9237C58.3099 14.7139 58.5104 14.5041 58.5104 14.1894C58.5104 13.8747 58.4101 13.56 58.1093 13.3502C57.9088 13.1405 57.5078 12.9307 57.0065 12.8258C56.5052 12.616 56.1042 12.4062 55.8034 12.1964C55.5026 11.8817 55.4023 11.567 55.4023 11.1474C55.4023 10.7279 55.6029 10.3083 55.9036 9.99359C56.2044 9.67891 56.7057 9.46912 57.207 9.46912C57.7083 9.46912 58.1093 9.57401 58.4101 9.8887C58.7109 10.2034 58.9114 10.4132 59.0117 10.7279L58.3099 11.0425C58.2096 10.8328 58.1093 10.623 57.9088 10.5181C57.7083 10.3083 57.4075 10.3083 57.1067 10.3083C56.806 10.3083 56.6055 10.4132 56.3047 10.5181C56.2044 10.7279 56.1042 10.9376 56.1042 11.2523C56.1042 11.4621 56.2044 11.6719 56.4049 11.8817C56.6054 12.0915 56.9062 12.1964 57.3073 12.3013C57.608 12.4062 57.8086 12.5111 58.0091 12.616C58.2096 12.7209 58.4101 12.8258 58.6106 13.0356C58.8112 13.1405 59.0117 13.3502 59.1119 13.6649C59.2122 13.8747 59.3124 14.1894 59.3124 14.5041C59.3124 14.8188 59.2122 15.1335 59.1119 15.3433C59.0117 15.553 58.8112 15.7628 58.6106 15.8677C58.4101 15.9726 58.2096 16.0775 58.0091 16.1824C57.7083 16.0775 57.5078 16.0775 57.207 16.0775Z"
      fill="var(--color-grayScale-white)"
      stroke="white"
      strokeWidth="0.2"
      strokeMiterlimit="10"
    />
    <path
      d="M61.117 15.9725H60.3149V9.67883H62.3201C62.8214 9.67883 63.2225 9.88862 63.6235 10.2033C64.0245 10.518 64.225 11.0425 64.225 11.5669C64.225 12.0914 64.0245 12.511 63.6235 12.9306C63.2225 13.2453 62.8214 13.4551 62.3201 13.4551H61.117V15.9725ZM61.117 12.6159H62.4204C62.7212 12.6159 63.0219 12.511 63.2225 12.3012C63.423 12.0914 63.5232 11.7767 63.5232 11.5669C63.5232 11.3572 63.423 11.0425 63.2225 10.8327C63.0219 10.6229 62.7212 10.518 62.4204 10.518H61.117V12.6159Z"
      fill="var(--color-grayScale-white)"
      stroke="white"
      strokeWidth="0.2"
      strokeMiterlimit="10"
    />
    <path
      d="M70.1404 15.1334C69.5388 15.7628 68.837 16.0775 67.9347 16.0775C67.0324 16.0775 66.3305 15.7628 65.729 15.1334C65.1274 14.5041 64.8267 13.7698 64.8267 12.8257C64.8267 11.8817 65.1274 11.1474 65.729 10.518C66.3305 9.88866 67.0324 9.57397 67.9347 9.57397C68.837 9.57397 69.5388 9.88866 70.1404 10.518C70.742 11.1474 71.0427 11.8817 71.0427 12.8257C71.0427 13.7698 70.742 14.5041 70.1404 15.1334ZM66.3305 14.6089C66.7316 15.0285 67.3331 15.3432 67.9347 15.3432C68.5362 15.3432 69.1378 15.1334 69.5388 14.6089C69.9399 14.1894 70.2407 13.56 70.2407 12.8257C70.2407 12.0915 70.0401 11.4621 69.5388 11.0425C69.1378 10.6229 68.5362 10.3082 67.9347 10.3082C67.3331 10.3082 66.7316 10.518 66.3305 11.0425C65.9295 11.4621 65.6287 12.0915 65.6287 12.8257C65.6287 13.56 65.9295 14.1894 66.3305 14.6089Z"
      fill="var(--color-grayScale-white)"
      stroke="white"
      strokeWidth="0.2"
      strokeMiterlimit="10"
    />
    <path
      d="M72.1455 15.9725V9.67883H73.0478L75.9554 14.6089V13.3502V9.67883H76.7574V15.9725H75.9554L72.8473 10.8327V12.0914V15.9725H72.1455Z"
      fill="var(--color-grayScale-white)"
      stroke="white"
      strokeWidth="0.2"
      strokeMiterlimit="10"
    />
    <path
      d="M78.1611 15.9726V9.67887H78.9632V15.9726H78.1611ZM78.8629 9.1544H78.1611L78.5622 8.00055H79.3642L78.8629 9.1544Z"
      fill="var(--color-grayScale-white)"
      stroke="white"
      strokeWidth="0.2"
      strokeMiterlimit="10"
    />
    <path
      d="M81.7705 15.9725L79.665 9.67883H80.5674L82.1715 14.8187L83.9762 9.67883H84.8785L82.6728 15.9725H81.7705Z"
      fill="var(--color-grayScale-white)"
      stroke="white"
      strokeWidth="0.2"
      strokeMiterlimit="10"
    />
    <path
      d="M89.1892 10.4131H86.4823V12.4061H88.9887V13.1404H86.4823V15.1334H89.1892V15.9725H85.6802V9.67883H89.1892V10.4131Z"
      fill="var(--color-grayScale-white)"
      stroke="white"
      strokeWidth="0.2"
      strokeMiterlimit="10"
    />
    <path
      d="M90.3926 15.9725V9.67883H91.1947V15.2383H93.8014V15.9725H90.3926Z"
      fill="var(--color-grayScale-white)"
      stroke="white"
      strokeWidth="0.2"
      strokeMiterlimit="10"
    />
    <path
      d="M96.8091 15.9725V9.67883H97.7114L100.619 14.6089V13.3502V9.67883H101.421V15.9725H100.619L97.5109 10.8327V12.0914V15.9725H96.8091Z"
      fill="var(--color-grayScale-white)"
      stroke="white"
      strokeWidth="0.2"
      strokeMiterlimit="10"
    />
    <path
      d="M107.738 15.1334C107.136 15.7628 106.434 16.0775 105.532 16.0775C104.63 16.0775 103.928 15.7628 103.326 15.1334C102.725 14.5041 102.424 13.7698 102.424 12.8257C102.424 11.8817 102.725 11.1474 103.326 10.518C103.928 9.88866 104.63 9.57397 105.532 9.57397C106.434 9.57397 107.136 9.88866 107.738 10.518C108.339 11.1474 108.64 11.8817 108.64 12.8257C108.54 13.7698 108.239 14.5041 107.738 15.1334ZM103.827 14.6089C104.228 15.0285 104.83 15.3432 105.432 15.3432C106.033 15.3432 106.635 15.1334 107.036 14.6089C107.437 14.1894 107.738 13.56 107.738 12.8257C107.738 12.0915 107.537 11.4621 107.036 11.0425C106.635 10.6229 106.033 10.3082 105.432 10.3082C104.83 10.3082 104.228 10.518 103.827 11.0425C103.426 11.4621 103.226 12.0915 103.226 12.8257C103.226 13.56 103.426 14.1894 103.827 14.6089Z"
      fill="var(--color-grayScale-white)"
      stroke="white"
      strokeWidth="0.2"
      strokeMiterlimit="10"
    />
    <rect
      x="0.5"
      y="0.500549"
      width="151"
      height="45"
      rx="7.5"
      stroke="#A6A6A6"
    />
    <defs>
      <linearGradient
        id="paint0_linear_32042_47839"
        x1="27.8303"
        y1="11.4723"
        x2="10.2443"
        y2="28.281"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset="0.00657445" stopColor="#00A1FF" />
        <stop offset="0.2601" stopColor="#00BEFF" />
        <stop offset="0.5122" stopColor="#00D2FF" />
        <stop offset="0.7604" stopColor="#00DFFF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_32042_47839"
        x1="39.8958"
        y1="23.3168"
        x2="15.6362"
        y2="23.3168"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset="0.4087" stopColor="#FFBD00" />
        <stop offset="0.7754" stopColor="#FFA500" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_32042_47839"
        x1="30.8653"
        y1="25.7238"
        x2="7.01726"
        y2="48.5178"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_32042_47839"
        x1="13.2901"
        y1="2.5211"
        x2="23.9393"
        y2="12.6995"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset="0.0685" stopColor="#2DA771" />
        <stop offset="0.4762" stopColor="#15CF74" />
        <stop offset="0.8009" stopColor="#06E775" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
    </defs>
  </svg>
)

export default AppAndroidIcon
